import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { CheckCircle, Error, Info } from "@mui/icons-material";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { useMaterialUIController } from "../../context";
import { useUserDetails } from "../../context/auth";
const ManagerManagement = () => {
  const navigate = useNavigate();
  const {AccessData} = useUserDetails();
  const [controller, dispatch] = useMaterialUIController();
  const { userAuthenticated } = controller;

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [managerList, setManagerList] = useState([]);

  const managerListTable = {
    columns: [
      {
        field: "employeeId",
        headerName: "Employee Id",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        field: "firstName",
        headerName: "User name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        field: "department",
        headerName: "Department",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
        {
        field: "department",
        headerName: "Department",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },  {
        field: "designation",
        headerName: "Designation",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        field: "isActive",
        headerName: "Is Active",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        type: "status",
      },
    ],
    rows: managerList.map((manager) => ({
      id: manager.id,
      employeeId: manager.user.empid,
      firstName: manager.user.firstName.toUpperCase(),
      department: manager.user.department,
      designation:manager.user.designation,
      status: {
        label: manager.status === true ? "Active" : "inActive",
        color:
          (manager.status === true && "success") ||
          (manager.status === false && "error") ||
          "info",
        icon: (manager.status === true && <CheckCircle />) ||
          (manager.status === false && <Error />) || <Info />,
      },
    })),
  };

  useEffect(() => {
    // if (userAuthenticated) {
    getManagerList();
    // }
  }, []);

  const getManagerList = async () => {
    const query = `  
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      department
      designation
      firstName
      lastName
      
    }
  }
}
`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response:", response.data);

      const managerList = response.data.data.allManagers;
      setManagerList(managerList);
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", managerList);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const handleNewManager = () => {
    navigate("/manager-management/add-manager");
  };

  const onManagerListClick = (e) => {
    console.log("onManagerListClick:", e?.id, e);
    if (e?.id) {
      navigate(`/manager-management/manager-details?id=${e?.id}`);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Manager management list
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of managers that you can get details of manager.
                            </MaterialTypography> */}
              </Stack>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddManger" && item.can_access
                ) && (
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewManager()}
              >
                Manager
              </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          customHeight={500}
          rows={managerListTable.rows}
          columns={managerListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onManagerListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No manager management found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any manager details. Click on the "Add
                  Manager Management" button to start adding manager management.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ManagerManagement;
